import React from 'react';
import AixueHeader from '@/components/AixueHeader/index';
import styles from './index.module.scss';

export default function Screen1() {
  return (
    <section className={styles['screen1-cover']}>
      {/* 头部导航 */}
      <div className={styles['screen1-header']}>
        <AixueHeader title="爱学" />
      </div>

      <div className={styles['screen1-wrap']}>
        <div className={styles['screen1-content']}>
          <div className={styles['screen1-titleImg']}></div>
          <div className={styles['screen1-desc']}>AI学就爱学·你的专属AI一对一导师</div>
        </div>
      </div>
    </section>
  );
}
